import React from 'react';
import BaseLayout from 'Components/Layout/BaseLayout';
import { useQuery } from 'Utils/Functions';
import healthIcon from '../../Assets/Icons/health-icon.png';
import calendarIcon from '../../Assets/Icons/calendar-white.svg';
import priceRangeIcon from '../../Assets/Icons/price-range.png';
import gendarIcon from '../../Assets/Icons/gendar-icon.png';
import placeholderIcon from '../../Assets/Icons/placeholder-white-icon.svg';
import Weekend from '../../Assets/images/unifit-weekend-wellness-image.jpg';
import bodyProImage from '../../Assets/images/unifit-bodypro-health-check-up.jpg';
import seniorCitizen from '../../Assets/images/unifit-senior-citizen-health-check-up.jpg';
import fevarProfile from '../../Assets/images/unifit-fever-profile.jpg';
import Wednesday from '../../Assets/images/Unifit Wednesday Wellness—Diabetes Care.jpg';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function Unifit() {
  const isHeaderShow = useQuery('remove');
  const location = useLocation();

  return (
    <BaseLayout
      removeFooterAndHeader={isHeaderShow}
      _class={'header-top-offset booking-process-header my-booking-footer'}
    >
      <Helmet>
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_URL}${location.pathname}`}
        />
        <title>
          Unifit by Unipath - Affordable Health Checkup Packages for You
        </title>
        <meta
          name="keywords"
          content=""
        />
        <meta
          name="description"
          content="Unifit, by Unipath Specialty Laboratory, offers direct-to-customer health packages for preventive care. Book a full body checkup and stay healthy!"
        />
      </Helmet>

      <section className="unifit-section pt-0 tag-interchange">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading-component">
                <h1>Unifit</h1>
              </div>
              <div className="unifit-wrapper">
                <p>
                  Unifit division provides direct-to-customer health packages on
                  behalf of Unipath Specialty Laboratory. This division has
                  taken initiative to launch value-for-money health check-up
                  packages across all Unipath branches. The most popular Unifit
                  health packages are:
                </p>
                <ul>
                  <li>Unifit Weekend Wellness (Saturday & Sunday)</li>
                  <li>Unifit BodyPro Health Check-up (Daily)</li>
                  <li>Unifit Senior Citizen Health Check-up (Daily)</li>
                  <li>Unifit Fever Profile (Daily)</li>
                  <li>Unifit Wednesday Wellness—Diabetes Care (Wednesday)</li>
                </ul>
                <div className="unifit-content-wrap">
                  <h2>Unifit Weekend Wellness</h2>
                  <div className="slider-content-divide">
                    <div className="slider-content-divide-left">
                      <div className="slider-content-items mb-3">
                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={healthIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Number of Health Packages: <strong>7</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={priceRangeIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Price Range: <strong>Rs.399-Rs.2499</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={gendarIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Gender: <strong>Male & Female</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={calendarIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Days: <strong>Saturday & Sunday</strong>
                          </div>
                        </div>
                      </div>

                      <div className="slider-content-items location-slider-content-items">
                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={placeholderIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Ahmedabad, Surat, Jamnagar, Anand, Jaipur, Kolkata,
                            Mehsana, Vadodara, Delhi
                          </div>
                        </div>
                      </div>
                      <br />

                      <div className="slider-content-items location-slider-content-items">
                        <div className="slider-content-item">
                          <div className="slider-weekend-wellness-content">
                            <strong>Note:</strong> Unifit Weekend Wellness is
                            available in Jamnagar on{' '}
                            <strong>Thursday & Saturday</strong>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="slider-content-divide-right">
                      <figure className="slider-content-image">
                        <img
                          alt=""
                          src={Weekend}
                        />
                      </figure>
                    </div>
                  </div>
                </div>

                <div className="unifit-content-wrap">
                  <h2>Unifit BodyPro Health Check-up</h2>
                  <div className="slider-content-divide">
                    <div className="slider-content-divide-right">
                      <figure className="slider-content-image">
                        <img
                          alt=""
                          src={bodyProImage}
                        />
                      </figure>
                    </div>

                    <div className="slider-content-divide-left">
                      <div className="slider-content-items mb-3">
                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={healthIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Number of Health Packages: <strong>16</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={priceRangeIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Price Range: <strong>Rs.1500-Rs.4500</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={gendarIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Gender: <strong>Male & Female</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={calendarIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Days: <strong>Daily </strong>
                          </div>
                        </div>
                      </div>

                      <div className="slider-content-items location-slider-content-items">
                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={placeholderIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Ahmedabad, Surat, Jamnagar, Anand, Jaipur, Kolkata,
                            Mehsana, Vadodara, Delhi
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="unifit-content-wrap">
                  <h2>Unifit Senior Citizen Health Check-up</h2>
                  <div className="slider-content-divide">
                    <div className="slider-content-divide-left">
                      <div className="slider-content-items mb-3">
                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={healthIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Number of Health Packages: <strong>2</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={priceRangeIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Price Range:{' '}
                            <strong>Male -Rs.2999 and Female – Rs.2799</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={gendarIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Gender: <strong>Male & Female</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={calendarIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Days: <strong>Daily </strong>
                          </div>
                        </div>
                      </div>

                      <div className="slider-content-items location-slider-content-items">
                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={placeholderIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Ahmedabad, Surat, Jamnagar, Anand, Jaipur, Kolkata,
                            Mehsana, Vadodara, Delhi
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="slider-content-divide-right">
                      <figure className="slider-content-image">
                        <img
                          alt=""
                          src={seniorCitizen}
                        />
                      </figure>
                    </div>
                  </div>
                </div>

                <div className="unifit-content-wrap">
                  <h2>Unifit Fever Profile</h2>
                  <div className="slider-content-divide">
                    <div className="slider-content-divide-right">
                      <figure className="slider-content-image">
                        <img
                          alt=""
                          src={fevarProfile}
                        />
                      </figure>
                    </div>

                    <div className="slider-content-divide-left">
                      <div className="slider-content-items mb-3">
                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={healthIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Number of Health Packages: <strong>2</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={priceRangeIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Price Range: <strong>Rs.1499 & Rs.3499</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={gendarIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Gender: <strong>Male & Female</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={calendarIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Days: <strong>Daily </strong>
                          </div>
                        </div>
                      </div>

                      <div className="slider-content-items location-slider-content-items">
                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={placeholderIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Ahmedabad, Surat, Jamnagar, Anand, Jaipur, Kolkata,
                            Mehsana, Vadodara, Delhi
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="unifit-content-wrap">
                  <h2>Unifit Wednesday Wellness—Diabetes Care</h2>
                  <div className="slider-content-divide">
                    <div className="slider-content-divide-left">
                      <div className="slider-content-items mb-3">
                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={healthIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Number of Health Packages: <strong>3</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={priceRangeIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Price Range: <strong>Rs.399 & Rs.1599</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={gendarIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Gender: <strong>Male & Female</strong>
                          </div>
                        </div>

                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={calendarIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Days: <strong>Wednesday </strong>
                          </div>
                        </div>
                      </div>

                      <div className="slider-content-items location-slider-content-items">
                        <div className="slider-content-item">
                          <div className="item-icon">
                            <img
                              alt=""
                              src={placeholderIcon}
                            />
                          </div>
                          <div className="slider-weekend-wellness-content">
                            Ahmedabad
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="slider-content-divide-right">
                      <figure className="slider-content-image">
                        <img
                          alt=""
                          src={Wednesday}
                        />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </BaseLayout>
  );
}

export default Unifit;
